<div class="  marign_10">
    <form *ngIf="contentMgmtData" class="form-wrapper" name="formContentManager" #formContentManager="ngForm" (ngSubmit)="save()" autocomplete="off">
        <fieldset class="scheduler-border">
            <legend class="scheduler-border">Content Management Page Editing</legend>

            <div class="content_management_margin">
                <div class="row ">
                    <div class="col-sm-6" style="margin-right:auto;">
                        <div class="form-group">
                            <label style="text-decoration: solid">Pages:</label>
                            <select class="form-control" name="pages" [(ngModel)]="contentMgmtData.ID" required (ngModelChange)="getPage()">
                                <option value="" style="display: none">Select Page</option>
                                <option *ngFor="let data of pages" [value]="data.Value">{{data.Text}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6" style="margin-left:auto;margin-right:auto;">
                        <div class="form-group marign_10">
                            <label style="text-decoration:solid"> Page Name:</label>
                            <input id="pageName" type="text" name="pageName" placeholder="Page Name" #pageName="ngModel" class="form-control" [ngClass]="{ 'is-invalid': pageName.invalid && (pageName.dirty || pageName.touched)}" [(ngModel)]="contentMgmtData.PageName" minlength="3"
                                maxlength="100" required />
                            <div *ngIf="pageName.invalid && (pageName.dirty || pageName.touched)" class="invalid-feedback">
                                <div *ngIf="pageName.errors?.required">Page Name is required</div>
                                <div *ngIf="pageName.errors?.minlength || pageName.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" style="margin-left:auto;margin-right:auto;">
                        <div class="form-group marign_10">
                            <label style="text-decoration:solid"> Page Title :</label>
                            <input id="pageTite" name="pageTite" type="text" placeholder="Page Title" #pageTite="ngModel" class="form-control" [ngClass]="{ 'is-invalid': pageTite.invalid && (pageTite.dirty || pageTite.touched)}" [(ngModel)]="contentMgmtData.PageTitle" minlength="3"
                                maxlength="100" required />
                            <div *ngIf="pageTite.invalid && (pageTite.dirty || pageTite.touched)" class="invalid-feedback">
                                <div *ngIf="pageTite.errors?.required">Page Tite is required</div>
                                <div *ngIf="pageTite.errors?.minlength || pageTite.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-lg-12" style="margin-left:auto;margin-right:auto;">
                        <div class="form-group marign_10">
                            <label style="text-decoration: solid"> Page Content :</label>
                            <angular-editor name="editor" [(ngModel)]="contentMgmtData.PageContents">
                            </angular-editor>
                            <!-- <text-angular ng-model="contentManager.viewModel.PageContents" placeholder="Enter Page Content Here."></text-angular> -->
                        </div>
                    </div>
                </div>


                <div class="pull-right marign_10 margin_botm_10 orders_sum_top">
                    <button type="submit" class="btn btn-primary button_ri8" [disabled]="!formContentManager.valid">Save</button>
                    <button class="btn btn-grey btn-default" type="reset" style="background-color:black ;color:white">Cancel</button>
                    <!-- <button class="btn btn-grey" style="background-color:black ;color:white" ng-click="contentManagement.cancelSearch()">Cancel</button> -->
                </div>


            </div>

        </fieldset>



    </form>
</div>